import React, { useEffect, useState } from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import {
  useGetCompanyAccountQuery,
  useGetMeQuery,
} from "../../services/ScopeStackAPI";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";

const LaunchDarklyProvider = ({ children, accountSlug }) => {
  const ldClient = useLDClient();
  const userSignedIn = useSelector((state: RootState) => state.auth.authorized);
  const { data: currentUser } = useGetMeQuery();
  const { data: account } = useGetCompanyAccountQuery(accountSlug);
  const [identified, setIdentified] = useState(false);

  useEffect(() => {
    if (userSignedIn && currentUser && account && ldClient) {
      const context = {
        user: {
          key: currentUser.attributes.uuid,
          email: currentUser.attributes.email,
          name: currentUser.attributes.name,
        },
        organization: {
          key: account.attributes.uuid,
          name: account.attributes.name,
        },
        kind: "multi",
      };

      // Fallback: if identify hangs (e.g. dev/dummyclient), unblock after 3s
      const timeout = setTimeout(() => setIdentified(true), 3000);
      ldClient
        .identify(context)
        .then(() => setIdentified(true))
        .catch(() => setIdentified(true))
        .finally(() => clearTimeout(timeout));
    }
  }, [ldClient, currentUser, account, userSignedIn]);

  if (!identified) return <ScopeStackSpinner />;

  return <>{children}</>;
};

export default LaunchDarklyProvider;
